import React from 'react';
import './PlayersList.css';
import PlayersListItem from '../PlayersListItem';

class PlayersList extends React.Component {
  shouldComponentUpdate(nextProps) {
    const {
      orderedPlayersIds,
      combinedStats,
      showPlayersStatsAllGames,
      showPlayersStatsWonGames,
      showPlayersStatsLostGames,
      showPlayersStatsHomeGames,
      showPlayersStatsAwayGames,
      showPlayersStatsTotal
    } = this.props;

    return orderedPlayersIds.toString() !== nextProps.orderedPlayersIds.toString()
      || combinedStats !== nextProps.combinedStats
      || showPlayersStatsAllGames !== nextProps.showPlayersStatsAllGames
      || showPlayersStatsWonGames !== nextProps.showPlayersStatsWonGames
      || showPlayersStatsLostGames !== nextProps.showPlayersStatsLostGames
      || showPlayersStatsHomeGames !== nextProps.showPlayersStatsHomeGames
      || showPlayersStatsAwayGames !== nextProps.showPlayersStatsAwayGames
      || showPlayersStatsTotal !== nextProps.showPlayersStatsTotal;
  }

  render() {
    const {
      playersData,
      orderedPlayersIds,
      combinedStats,
      showPlayersStatsAllGames,
      showPlayersStatsWonGames,
      showPlayersStatsLostGames,
      showPlayersStatsHomeGames,
      showPlayersStatsAwayGames,
      showPlayersStatsTotal,
      season,
      league,
      team,
      editMode,
      onPlayerContentChange,
      onPlayerConfigurationChange
    } = this.props;

    return <div>
      { orderedPlayersIds.map(id => playersData[id] &&
        <PlayersListItem key={ id }
                         playerData={ playersData[id] }
                         { ...{ combinedStats,
                                showPlayersStatsAllGames,
                                showPlayersStatsWonGames,
                                showPlayersStatsLostGames,
                                showPlayersStatsHomeGames,
                                showPlayersStatsAwayGames,
                                showPlayersStatsTotal,
                                season,
                                league,
                                team,
                                editMode,
                                onPlayerContentChange,
                                onPlayerConfigurationChange } } />)
      }
    </div>
  }
}

export default PlayersList;



// WEBPACK FOOTER //
// ./src/features/scout-report/components/PlayersList/PlayersList.js